import React, { Component } from "react";
import { connect } from "react-redux";

import { fetchProducts, deleteProduct } from "actions/product";
import { toggleconfirmationPopup, toggleNotification } from "actions/toggle";
import SearchForm from "components/SearchForm";
import Table from "./Table";
import Pagination from "components/Pagination";
import HitComponent from "./HitComponent";
import { InstantSearch, SearchBox, PoweredBy } from "components/algolia-dom";
import MagicConnector from "components/algolia-dom/MagicConnector";
import ProcessButton from "components/Process/ProcessButton";
import ImportButton from "components/Process/ImportButton";
import { exportProducts } from "api/exportProducts";
import { getDownloadResultUrl } from "api/fetchExportStatus";

class ProductIndex extends Component {
  excludeRecords = [];
  refreshSearch = false;

  componentDidMount() {
    const { companyURL: company_url } = this.props.match.params;
    this.props.fetchProducts({ company_url });
  }

  onPaginationClick = page => event => {
    const { companyURL: company_url } = this.props.match.params;
    this.props.fetchProducts({ company_url, page });
  };

  onSearchFormSubmit = data => {
    const { companyURL: company_url } = this.props.match.params;
    const search = {};
    if (data.search_term) {
      search[data.search_by] = data.search_term;
    }
    this.props.fetchProducts({ company_url, ...search });
  };  

  handleProductDelete = id => event => {
    this.refreshSearch = false;
    const { toggleconfirmationPopup } = this.props;
    toggleconfirmationPopup(true, {
      onClickConfirm: () => {
        this.deleteProductProcess(id);
      }
    });
  };

  afterImported = r => {
    if (r.success) {
      toggleNotification(true, {
        infoClassName: "is-success",
        message: "Import Product Success"
      });
      this.props.fetchProducts({
        company_url: this.props.match.params.companyURL
      });
    } else {
      toggleNotification(true, {
        infoClassName: "is-danger",
        message: "Import Product Failed"
      });
      window.open(
        getDownloadResultUrl(r.downloadResult, {
          company_url: this.props.match.params.companyURL,
          ...this.props.match.params
        })
      );
    }
  };

  deleteProductProcess(id) {
    const {
      toggleNotification,
      toggleconfirmationPopup,
      deleteProduct,
      match
    } = this.props;
    const { companyURL: company_url } = match.params;
    deleteProduct(id, { company_url })
      .then(() => {
        this.props.fetchProducts({ company_url });
        this.excludeRecords.push(id);
        this.refreshSearch = true;
        toggleNotification(true, {
          infoClassName: "is-success",
          message: "Delete Product Success"
        });
        toggleconfirmationPopup(false, {});
      })
      .catch(({ message }) => {
        toggleNotification(true, { infoClassName: "is-danger", message });
        toggleconfirmationPopup(false, {});
      });
  }

  render() {
    const {
      products,
      setting,
      match: { params }
    } = this.props;
    const { companyURL } = params;

    return (
      <div>
        <div className="box">
          <SearchForm
            onSearchFormSubmit={this.onSearchFormSubmit}
            options={[{ label: "By Title", value: "title" }, { label: "By SKU", value: "sku" }]}
          />
          <div style={{ marginTop: 15 }}>
            <ImportButton
              params={{ company_url: companyURL }}
              afterImported={this.afterImported}
              icon="fa-upload"
            />
            &nbsp;
            <ProcessButton
              label="Export"
              onProcess={exportProducts}
              params={{ company_url: companyURL }}
              icon="fa-download"
            />
          </div>
          <Table
            products={products}
            companyURL={companyURL}
            onClickDelete={this.handleProductDelete}
          />
          <Pagination
            onClick={this.onPaginationClick}
            currentPage={products.current_page}
            lastPage={products.last_page}
            range="4"
            modifyClasses="is-right"
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({
  authUser,
  products,
  confirmationPopupActive,
  setting
}) => ({
  authUser,
  products,
  confirmationPopupActive,
  setting
});

export default connect(mapStateToProps, {
  fetchProducts,
  deleteProduct,
  toggleconfirmationPopup,
  toggleNotification
})(ProductIndex);
